import { createContext, useContext, useState, type ReactNode } from 'react'

const PRIVACY_STORAGE_KEY = 'troia-privacy-mode'

interface PrivacyContextType {
  isPrivacyMode: boolean
  togglePrivacyMode: () => void
}

const PrivacyContext = createContext<PrivacyContextType | undefined>(undefined)

function getStoredPrivacyMode(): boolean {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(PRIVACY_STORAGE_KEY) === 'true'
}

interface PrivacyProviderProps {
  children: ReactNode
}

export function PrivacyProvider({ children }: PrivacyProviderProps) {
  const [isPrivacyMode, setIsPrivacyMode] = useState<boolean>(getStoredPrivacyMode)

  const togglePrivacyMode = () => {
    const newValue = !isPrivacyMode
    setIsPrivacyMode(newValue)
    localStorage.setItem(PRIVACY_STORAGE_KEY, String(newValue))
  }

  return (
    <PrivacyContext.Provider value={{ isPrivacyMode, togglePrivacyMode }}>
      {children}
    </PrivacyContext.Provider>
  )
}

export function usePrivacy(): PrivacyContextType {
  const context = useContext(PrivacyContext)
  if (context === undefined) {
    throw new Error('usePrivacy must be used within a PrivacyProvider')
  }
  return context
}
